import script from "./myContentsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./myContentsDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./myContentsDetailPage.vue?vue&type=style&index=0&id=659e6744&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659e6744"]])

export default __exports__